import React, { useEffect } from "react";
import { Profile } from "../../../components/datagrid/CRM/AdmissionRegister/StudentProfile/Profile";
import { ProfileMountIfParentSetOpen } from "../../../components/datagrid/CRM/AdmissionRegister/StudentProfile/ProfileMountIfParentSetOpen";
import { use } from "react";
import { useDispatch } from "react-redux";

const StudentProfileParentLand = ({courseEnrollmentId,url,storeName,open,setOpen}) => {
    const dispatch=useDispatch()
    useEffect(() => {
        if (open) {
            dispatch(url(courseEnrollmentId))
        }
    }, [open]);
  return <ProfileMountIfParentSetOpen url={url} params={courseEnrollmentId} storeName={storeName} open={open} setOpen={setOpen} />;
};

export default StudentProfileParentLand;
